import React from "react";
import Landing from "../components/Landing";
import Mainpage from "../components/Mainpage";
const Home = () => {
  return (
    <>
      <Landing />
      <Mainpage />
    </>
  );
};

export default Home;
